import React, { useState } from "react";
import PropTypes from "prop-types";
import { Grid, Typography, TextareaAutosize } from "@material-ui/core";
import Modal from "../../../app/components/modals/Modal";
import useStyles from "./styles";
import { translate as t } from "../../translate/localization";
import CobeeButton from "../../../app/components/CobeeButton";
import { hideModal } from "../../../usecases/commons/hide-modal";

export default function RejectRentingModal({
  isLoading,
  callback,
  defaultMessage,
}) {
  const { container, row, buttonRow, textArea } = useStyles();

  const [rejectionReason, setRejectionReason] = useState(defaultMessage || "");

  return (
    <Modal title={t("request-section.deny-renting-request")}>
      <Grid item xs={12} container justify="center" className={container}>
        <Grid item xs={12} className={row}>
          <Typography variant="body2">
            {t("request-section.indicate-motive-of-denial-message")}
          </Typography>
        </Grid>
        <Grid item xs={12} className={row}>
          <TextareaAutosize
            value={rejectionReason}
            onChange={(e) => setRejectionReason(e.target.value)}
            className={textArea}
            placeholder={t("request-section.denial-message-placeholder")}
          />
        </Grid>

        <Grid
          item
          container
          xs={12}
          justify="center"
          alignItems="center"
          className={buttonRow}
        >
          <CobeeButton styleType="secondary" onClick={hideModal}>
            {t("actions.cancel")}
          </CobeeButton>
          <CobeeButton
            styleType="primary"
            onClick={() => callback({ rejectionReason })}
            isLoading={isLoading}
            disabled={rejectionReason.length < 1}
          >
            {t("actions.deny-request")}
          </CobeeButton>
        </Grid>
      </Grid>
    </Modal>
  );
}

RejectRentingModal.defaultProps = {
  defaultMessage: undefined,
  isLoading: false,
  callback: () => {},
};

RejectRentingModal.propTypes = {
  callback: PropTypes.func,
  defaultMessage: PropTypes.string,
  isLoading: PropTypes.bool,
};
